export const getMaxDate = (date: Date): Date | undefined => {
  if (!date) return undefined;
  const newDate = new Date(date);
  return new Date(newDate.setDate(newDate.getDate() - 1));
};
